








import { defineComponent, PropType, ref, useFetch } from '@nuxtjs/composition-api';
import StaffProductReviewCard from '~/components/pages/Staff/StaffProductReviewCard.vue';
import { useStore } from '~/composables/useStore';
import { DynamicPartsStaffReview } from '~/types/modules/contents';
import { StaffReview } from '~/types/modules/staff';

export default defineComponent({
  components: {
    StaffProductReviewCard,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsStaffReview>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const review = ref<StaffReview>();

    useFetch(async () => {
      try {
        review.value = await store.dispatch('modules/staff/fetchStaffReviewDetail', {
          reviewId: props.item.staff_review_id,
        });
      } catch {
        // 何もしない
      }
    });

    return {
      review,
    };
  },
});
